import { colors } from '../../packages/colors';

export const sxStyles = {
  statusIconBase: subStep => ({
    width: subStep ? '16px' : '24px',
    height: subStep ? '16px' : '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    zIndex: 1,
    marginTop: subStep ? '2px' : '0px',
  }),
  invalidStatusIconBase: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxShadow: `inset 0 0 0 3px ${colors.warning600}`,
  },

  statusIconCompleted: subStep => ({
    backgroundColor: subStep ? colors.success500 : colors.success200,
    '& svg': {
      width: '16px',
      height: '16px',
    },
  }),
  statusIconInProgress: {
    backgroundColor: colors.primary500,
    '& svg': {
      width: '10px',
      height: '10px',
    },
  },
  statusIconError: {
    backgroundColor: colors.error,
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
  statusIconInvalid: {
    '& svg': {
      width: '28px',
      height: '28px',
    },
  },
  stepProcessContainer: {
    background: 'white',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  innerContainer: {
    background: colors.primary25,
    borderRadius: '8px',
    padding: '24px',
    border: `4px solid ${colors.primary100}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 184px)',
  },
  stepProcessHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  stepsList: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '32px',
    paddingRight: '8px',
  },
  stepItems: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  stepMain: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    paddingBottom: '16px',
    flex: 1,
  },
  stepText: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    flex: 1,
  },
  message: {
    flex: 1,
  },
  subStepItems: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '8px',
    marginLeft: '32px',
    '&:last-child': {
      marginBottom: '8px',
    },
  },
  stepIconContainer: substep => ({
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: `${substep ? 16 : 24}px`,
  }),
  connectingLine: factor => ({
    position: 'absolute',
    top: factor ? '2px' : '0px',
    width: '2px',
    height: factor ? `${factor}px` : '18px',
    backgroundColor: colors.neutral100,
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: 56,
    right: 56,
  },
  button: {
    minWidth: 'auto',
    padding: '8px 16px',
  },
  connectingToLabcorpContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};
